module.exports = __webpack_public_path__ + "static/media/26UNRWA11.202d4598.jpg";